import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/kalender-hijriah/$hyear/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: `/en/hijri-calendar/${params.hyear}/` } as any);
  },
  component: () => null,
});
